MainView   = require("views/main")

class AppRouter extends Backbone.Router

  initialize: ->
    @mainView = new MainView(el: "body")

  routes:
    "slide(/:index)(?:query)": "slide"
    "*default": "default"

  default: ->
    @navigate "slide/1", true

  slide: (index = 1, query = "") ->
    params = {}

    for param in query.split("&") when param
      [key, val] = param.split("=")
      params[key] = try JSON.parse(val) catch val

    @mainView.display("slides", _.extend params, { index })

module.exports = AppRouter
